// ABOUTME: Tone palette shared by badges and notices — the one place status colours live.
// ABOUTME: border + surface + text per tone, straight from the design system (docs/DESIGN_SYSTEM.md §2).

/**
 * A status has a tone, not a colour. Components pick the tone; this file decides how it looks,
 * so a green "paid" badge and a green "paid" plate can never drift apart.
 */
export type CTone = "neutral" | "info" | "success" | "warning" | "danger" | "dark"

/** Surface + border + text for each tone. The scale is 100 / 200 / 800 across the board. */
export const TONE_CLASS: Record<CTone, string> = {
  neutral: "border-gray-200 bg-gray-100 text-gray-800",
  info: "border-blue-200 bg-blue-100 text-blue-800",
  success: "border-green-200 bg-green-100 text-green-800",
  warning: "border-yellow-200 bg-yellow-100 text-yellow-800",
  danger: "border-red-200 bg-red-100 text-red-800",
  dark: "border-gray-700 bg-gray-800 text-gray-100",
}
